<div class="filter-panel">

  <!-- ── SORT BAR ── -->
  <div class="filter-section sort-section">
    <span class="section-label">Sortiraj</span>
    <div class="sort-pills">
      @for (opt of sortOptions; track opt.value) {
        <button
          class="pill"
          [class.active]="activeSort === opt.value"
          (click)="setSort(opt.value)"
          type="button">
          <span class="pill-icon">{{ opt.icon }}</span>
          {{ opt.label }}
        </button>
      }
    </div>
  </div>

  <!-- ── FILTER TOGGLE ── -->
  <div class="filter-divider">
    <button class="filter-toggle" (click)="toggleFilters()" type="button">
      <span class="toggle-icon">{{ filtersOpen ? '▲' : '▼' }}</span>
      Filtriraj vožnje
      @if (activeFilterCount > 0) {
        <span class="filter-badge">{{ activeFilterCount }}</span>
      }
    </button>
    @if (activeFilterCount > 0) {
      <button class="clear-btn" (click)="clearFilters()" type="button">
        Poništi filtere
      </button>
    }
  </div>

  <!-- ── FILTER BODY ── -->
  @if (filtersOpen) {
    <div class="filter-body">

      <!-- Datum -->
      <div class="filter-group">
        <label class="group-label">
          <span class="group-icon">📅</span> Datum vožnje
        </label>
        <div class="date-row">
          <div class="date-field">
            <span class="date-label">Od</span>
            <input
              type="date"
              class="date-input"
              [value]="dateFrom"
              (change)="onDateFromChange($event)"
              [max]="dateTo || todayStr" />
          </div>
          <span class="date-sep">–</span>
          <div class="date-field">
            <span class="date-label">Do</span>
            <input
              type="date"
              class="date-input"
              [value]="dateTo"
              (change)="onDateToChange($event)"
              [min]="dateFrom"
              [max]="todayStr" />
          </div>
          @if (dateFrom || dateTo) {
            <button class="inline-clear" (click)="clearDates()" type="button" title="Ukloni filtar datuma">✕</button>
          }
        </div>
        <!-- Brze opcije datuma -->
        <div class="quick-dates">
          <button class="quick-btn" [class.active]="activeQuickDate === 'today'" (click)="setQuickDate('today')"  type="button">Danas</button>
          <button class="quick-btn" [class.active]="activeQuickDate === 'week'"  (click)="setQuickDate('week')"   type="button">Ovaj tjedan</button>
          <button class="quick-btn" [class.active]="activeQuickDate === 'month'" (click)="setQuickDate('month')"  type="button">Ovaj mjesec</button>
          <button class="quick-btn" [class.active]="activeQuickDate === 'year'"  (click)="setQuickDate('year')"   type="button">Ova godina</button>
        </div>
      </div>

      <!-- Udaljenost slider -->
      <div class="filter-group">
        <label class="group-label">
          <span class="group-icon">📏</span> Prijeđena udaljenost
          <span class="range-display">
            <strong>{{ distanceMin }} km</strong> – <strong>{{ distanceMax }} km</strong>
          </span>
        </label>
        <div class="slider-wrapper">
          <span class="slider-bound">0 km</span>
          <div class="dual-slider">
            <input
              type="range"
              class="range-input range-min"
              [min]="0"
              [max]="maxDistance"
              [value]="distanceMin"
              (input)="onMinSlider($event)"
              step="1" />
            <input
              type="range"
              class="range-input range-max"
              [min]="0"
              [max]="maxDistance"
              [value]="distanceMax"
              (input)="onMaxSlider($event)"
              step="1" />
            <!-- Track fill -->
            <div
              class="range-track-fill"
              [style.left.%]="(distanceMin / maxDistance) * 100"
              [style.width.%]="((distanceMax - distanceMin) / maxDistance) * 100">
            </div>
          </div>
          <span class="slider-bound">{{ maxDistance }} km</span>
        </div>
      </div>

    </div>
  }

</div>